import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmComponent } from './confirm/confirm.component';
import { DirtyTrackingDirective } from './dirty-tracking/dirty-tracking.directive';
import { FocusMeDirective } from './focus-me/focus-me.directive';
import { LazyLoadDirective } from './lazy-load/lazy-load.directive';
import { YesNoCancelComponent } from './yes-no-cancel/yes-no-cancel.component';
import { TableSortingComponent } from './table-sorting/table-sorting.component';
import { MustEqualDirective, MustMatchDirective, ValidAddressDirective, ValidControlDirective } from './public/validators.model';
import { CallablePhoneNumberPipe, CFDateTimePipe, FunctionFilterPipe, FunctionSearchPipe, JoinPipe, LocalDatePipe, LocalDateTimePipe, LocalPrettyDatePipe, LocalPrettyDatePipeTime, LocalPrettyTimePipe, ObjectFilterPipe, ObjectOrFilterPipe, OrdinalPipe, PhoneNumberPipe, SafePipe, SearchFilterPipe } from './public/pipes.model';
import { FormsModule } from '@angular/forms';
import { ajaxCall } from './services/ajax-call.service';
import { CloneService } from './services/clone.service';
import { ConfirmService } from './services/confirm.service';
import { CssMgmtService } from './services/css-mgmt.service';
import { HttpClientModule } from '@angular/common/http';
import { DirtyTrackingService } from './dirty-tracking/dirty-tracking.service';
import { CanDeactivateGuard } from './dirty-tracking/dirty-tracking.guard';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MenuNavigationService } from './services/menu-navigation.service';
import { CopyClipboardDirective } from './clipboard/copy-clipboard.directive';
import { SidebarButtonComponent } from './sidebar-button/sidebar-button.component';
import { BrokenParagraphsComponent } from './broken-paragraphs/broken-paragraphs.component';
import { NotificationComponent } from './notification/notification.component';
import { DistanceService } from './services/distance.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { LoadingService } from './services/loading.service';
import { LoadingBaseComponent } from './public/loading-component.component';
import { AutocompleteAddressComponent } from './autocomplete-address/autocomplete-address.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GMAutoComplete } from './autocomplete-address/gm-autocomplete.directive';
import { LineClampCheckDirective } from './public/directives.model';

@NgModule({
  declarations: [
    MustMatchDirective,
    ValidControlDirective,
    ValidAddressDirective,
    ConfirmComponent,
    DirtyTrackingDirective,
    MustEqualDirective,
    CopyClipboardDirective,
    LocalDatePipe,
    LocalDateTimePipe,
    LocalPrettyDatePipe,
    LocalPrettyTimePipe,
    LocalPrettyDatePipeTime,
    CFDateTimePipe,
    OrdinalPipe,
    PhoneNumberPipe,
    SearchFilterPipe,
    JoinPipe,
    ObjectFilterPipe,
    ObjectOrFilterPipe,
    SafePipe,
    FunctionFilterPipe,
    FunctionSearchPipe,
    LazyLoadDirective,
    LineClampCheckDirective,
    FocusMeDirective,
    TableSortingComponent,
    YesNoCancelComponent,
    SidebarButtonComponent,
    BrokenParagraphsComponent,
    NotificationComponent,
    MessageModalComponent,
    CallablePhoneNumberPipe,
    LoadingBaseComponent,
    AutocompleteAddressComponent,
    GMAutoComplete,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgbModalModule,
    NgbTooltipModule,
    GoogleMapsModule,
    FontAwesomeModule
  ],
  providers: [
    CloneService,
    ConfirmService,
    CssMgmtService,
    CanDeactivateGuard,
    MenuNavigationService,
    LocalDatePipe,
    DistanceService,
    CallablePhoneNumberPipe,
    SearchFilterPipe
  ],
  exports: [
    LocalDatePipe,
    LocalDateTimePipe,
    CFDateTimePipe,
    LocalPrettyDatePipe,
    LocalPrettyTimePipe,
    LocalPrettyDatePipeTime,
    OrdinalPipe,
    PhoneNumberPipe,
    SearchFilterPipe,
    JoinPipe,
    ObjectFilterPipe,
    ObjectOrFilterPipe,
    SafePipe,
    FunctionFilterPipe,
    FunctionSearchPipe,
    MustMatchDirective,
    ValidControlDirective,
    ValidAddressDirective,
    ConfirmComponent,
    DirtyTrackingDirective,
    MustEqualDirective,
    LazyLoadDirective,
    LineClampCheckDirective,
    FocusMeDirective,
    CopyClipboardDirective,
    TableSortingComponent,
    SidebarButtonComponent,
    BrokenParagraphsComponent,
    CallablePhoneNumberPipe,
    AutocompleteAddressComponent,
    GMAutoComplete
  ],
})
export class CoreModule { }
